module.exports = __webpack_public_path__ + "img/export-monitors.7b17d60d.svg";